<div class="title">
  <h2 mat-dialog title>{{ 'sharedDialogs.addNewCompany.title' | transloco }}</h2>
  <mat-icon mat-dialog-close>close</mat-icon>
</div>

<mat-dialog-content [class.search-height]="!manualEntryName()"
  [class.form-height]="!!manualEntryName() && newAddressForm.disabled"
  [class.form-height-expanded]="newAddressForm.enabled">
  <mat-progress-bar [@slideOutUp]="animationState()" mode="indeterminate"></mat-progress-bar>

  @if(!manualEntryName()) {
  <section class="company-search">
    <mat-label class="xs required">{{ 'sharedDialogs.addNewCompany.companyName' | transloco }}</mat-label>
    <mat-form-field appearance="outline" class="white-input no-subscript-wrapper">
      <add-new-company-autocomplete [formControl]="companyName"
        (searchInProgress)="companySearchInProgress.set($event);" (navigate)="navigateToCompany($event)"
        (mdmCompanySelected)="createFromMdmCompany($event)"
        (manualEntryStarted)="manualEntryName.set($event)" />
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>
  </section>
  } @else {
  <section class="manual-entry-form" [formGroup]="manualEntryForm" [@contentSlide]>
    <mat-label class="xs required">{{ 'sharedDialogs.addNewCompany.companyName' | transloco }}</mat-label>
    <mat-form-field appearance="outline" class="white-input no-subscript-wrapper">
      <input matInput formControlName="name" readonly [placeholder]="'sharedDialogs.addNewCompany.enterCompanyName' | transloco" />
    </mat-form-field>

    <mat-label class="xs required">{{ 'sharedDialogs.addNewCompany.address' | transloco }}</mat-label>
    <mat-form-field appearance="outline" class="white-input no-subscript-wrapper">
      <add-new-company-address-autocomplete (addAddressClicked)="enableNewAddressForm()"
        (searchInProgress)="addressSearchInProgress.set($event); alreadyExistingCompanyAddressMatch.set(null)"
        (inputTextChange)="newAddressForm.disable(); newAddressForm.reset();" formControlName="address" />
    </mat-form-field>
    @if(manualEntryForm.get('address')?.hasError('city')) {
    <mat-error>
      {{ 'sharedDialogs.addNewCompany.errors.cityMissing' | transloco }}
    </mat-error>
    }
    @if(manualEntryForm.get('address')?.hasError('postal')) {
    <mat-error>
      {{ 'sharedDialogs.addNewCompany.errors.postalMissing' | transloco }}
    </mat-error>
    }
    @if(manualEntryForm.get('address')?.hasError('street')) {
    <mat-error>
      {{ 'sharedDialogs.addNewCompany.errors.streetMissing' | transloco }}
    </mat-error>
    }

    @if(alreadyExistingCompanyAddressMatch()) {
    <existing-company-warning [companyLink]="alreadyExistingCompanyAddressMatch()?.website!"
      [companyName]="alreadyExistingCompanyAddressMatch()?.name!" [companyId]="alreadyExistingCompanyAddressMatch()?.id"
      (linkClicked)="closeDialog()" />
    }

    @if(newAddressForm.enabled) {
    <section class="new-address-container" formGroupName="newAddress">
      <mat-label class="xs">{{ 'sharedDialogs.addNewCompany.address2' | transloco }}</mat-label>
      <mat-form-field appearance="outline" class="white-input no-subscript-wrapper">
        <input matInput formControlName="line2" [placeholder]="'sharedDialogs.addNewCompany.enterSuite' | transloco" />
      </mat-form-field>

      @if(newAddressForm.get('country')?.value === 'US') {
      <typeahead (click)="onFocusStateCity($event)" mode="single" httpMode="get" [label]="'sharedDialogs.addNewCompany.city' | transloco" noSubscriptWrapper
        splitCityState (stateEmitted)="onStateEmitted($event)" [optionsEndpoint]="cityTypeaheadEndpoint"
        (valueChange)="cityOptions.set($event)" [placeholder]="'sharedDialogs.addNewCompany.city' | transloco" className="xs required">
      </typeahead>
      } @else {
      <div class="grid-container">
        <div>
          <mat-label class="xs required">{{ 'sharedDialogs.addNewCompany.city' | transloco }}</mat-label>
          <mat-form-field appearance="outline" class="white-input no-subscript-wrapper">
            <input matInput formControlName="city" [placeholder]="'sharedDialogs.addNewCompany.enterCity' | transloco" />
          </mat-form-field>
        </div>
        <div>
          <mat-label class="xs" [class.required]="isStateRequired">{{ 'sharedDialogs.addNewCompany.stateProvince' | transloco }}</mat-label>
          <mat-form-field appearance="outline" class="white-input no-subscript-wrapper">
            @if(newAddressForm.get('country')?.value !== 'UK' && newAddressForm.get('country')?.value !== 'Other') {
            <mat-select formControlName="stateProvince" [placeholder]="'sharedDialogs.addNewCompany.selectStateProvince' | transloco">
              @for (state of stateOptions[newAddressForm.get('country')?.value!]; track state.abbreviation) {
              <mat-option [value]="state.abbreviation">
                {{ state.name }}
              </mat-option>
              }
            </mat-select>
            } @else {
            <input type="text" formControlName="stateProvince" matInput formControlName="stateProvince"
              [placeholder]="'sharedDialogs.addNewCompany.enterStateProvince' | transloco" />

            }
          </mat-form-field>
        </div>
      </div>
      }
      @if(newAddressForm.get('city')?.value) {
      <div class="grid-container">
        <div>
          <mat-label class="xs required">{{ 'sharedDialogs.addNewCompany.country' | transloco }}</mat-label>
          <mat-form-field appearance="outline" class="white-input no-subscript-wrapper">
            <mat-select formControlName="country" [placeholder]="'sharedDialogs.addNewCompany.selectCountry' | transloco">
              @for (country of countryOptions; track country.abbreviation) {
              <mat-option [value]="country.abbreviation">
                {{ country.name }}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        <div>
          <mat-label class="xs" [class.required]="isZipRequired">{{ 'sharedDialogs.addNewCompany.zip' | transloco }}</mat-label>
          <mat-form-field appearance="outline" class="white-input no-subscript-wrapper">
            <input matInput formControlName="postalCode" [placeholder]="'sharedDialogs.addNewCompany.enterZip' | transloco" />
          </mat-form-field>
        </div>
      </div>
      }
    </section>
    }

    <div class="grid-container">
      <div>
        <mat-label class="xs" [class.required]="manualEntryForm.get('website')?.enabled">{{ 'sharedDialogs.addNewCompany.website' | transloco }}</mat-label>
        <mat-form-field appearance="outline" class="white-input no-subscript-wrapper">
          <input matInput [placeholder]="'sharedDialogs.addNewCompany.enterWebsite' | transloco" formControlName="website" />
        </mat-form-field>
        @if(manualEntryForm.get('website')?.hasError('pattern')) {
        <mat-error>
          {{ 'sharedDialogs.addNewCompany.errors.invalidWebsite' | transloco }}
        </mat-error>
        }
      </div>

    </div>
    <mat-checkbox class="white-input" (change)="toggleWebsiteControl($event.checked)">{{ 'sharedDialogs.addNewCompany.noWebsite' | transloco }}</mat-checkbox>
  </section>
  }

</mat-dialog-content>
@if(manualEntryName()) {
<mat-dialog-actions [@contentSlide]>
  <button mat-stroked-button color="primary" (click)="reset()">{{ 'shared.common.back' | transloco }}</button>
  <button mat-flat-button color="primary" (click)="saveCompany()"
    [disabled]="isSaveDisabled">{{ 'shared.common.save' | transloco }}</button>

</mat-dialog-actions>
}